import { useCallback } from 'react';

const useAllowOnlyDecimal = () => {
    const handleKeyDown = useCallback((event) => {
        const allowedKeys = [
            'Backspace',
            'Tab',
            'ArrowLeft',
            'ArrowRight',
            'Delete',
            'Enter',
            'Home',
            'End',
        ];
        const isDigit = /^[0-9]$/.test(event.key);
        const isDot = event.key === '.';
        const isAllowedKey = allowedKeys.includes(event.key);
        const alreadyHasDot = (event.target.value || '').includes('.');

        if (isDot && alreadyHasDot) {
            event.preventDefault();
            return;
        }

        if (!isDigit && !isDot && !isAllowedKey) {
            event.preventDefault();
        }
    }, []);

    return handleKeyDown;
}

export default useAllowOnlyDecimal;
